import React from 'react';
import { PopUpNotification } from 'extracted-chat-components';

import {
  ButtonColor,
  ButtonShape,
  ButtonSize,
} from 'constants/enums';

const BeforeAppointmentPopUp = ({
  isNotificationPopUp,
  popUpNotificationData,
  showPopUpNotification,
}) => {
  const okHandler = () => {
    showPopUpNotification(false);
  };

  const acceptButton = {
    text: 'Okay',
    color: ButtonColor.WARNING,
    size: ButtonSize.XS,
    shape: ButtonShape.ROUNDED,
    handler: okHandler,
  };

  return (
    <PopUpNotification
      isOpen={isNotificationPopUp}
      title={popUpNotificationData.title}
      isTextNewLine={popUpNotificationData.isTextNewLine}
      acceptButton={acceptButton}
      isBigWidth={false}
    />
  );
};

export default BeforeAppointmentPopUp;
